import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://www.51cinema.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6">
        <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-600 py-4">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && <i className="ri-arrow-right-s-line mx-1 text-foreground-400"></i>}
              {item.href ? (
                <Link to={item.href} className="hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}

export function getCategoryBreadcrumb(slug: string) {
  const cat = categories.find(c => c.slug === slug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || slug },
  ];
}

export function getMovieBreadcrumb(movieTitle: string, categorySlug: string) {
  const cat = categories.find(c => c.slug === categorySlug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || categorySlug, href: `/category/${categorySlug}` },
    { label: movieTitle },
  ];
}